import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { useGameStatsStore } from '../../zustand/useGameStatsStore';

export const outpostReducer = (scratch: StatsSnapshot) => {
  const outpost = scratch.generators.outpost;

  // Only update if ticksCount is a multiple of ticksToGenerate
  const ticksToGenerate = outpost.ticksToGenerate ?? 1;
  if (useGameStatsStore.getState().getActiveTicksCount() % ticksToGenerate !== 0) {
    return;
  }

  const generatedElves = outpost.owned * outpost.baseGeneration;

  // Apply upgrades somehow, somewhere...

  scratch.generators.elf.owned += generatedElves;

  return;
};
